<template lang="pug">
.infobox
  .bal
    div
      div {{$t('ui.current_balance')}}
      .baltext
        span.myr-num(@click="$router.push('/deposit').catch(err => {})") RM {{$numeral(currentBalance).format("0,0.00")}}
        a.reload-mw(href="javascript:void(0)" @click="getBalance")
          i.fa-solid.fa-rotate-right
  //- .infobanner
    img(src="/images/depo/depo-banner.jpg")
</template>
<script>
export default{
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    currentBalance() {
      return this.$store.getters.balance
    },
  },
  methods:{
    getBalance() {
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                this.$store
                  .dispatch("user/logout")
                  .catch(err => {})
              });
            }
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
  }
}
</script>